import { useEffect, useState } from "react";
import { Form, InputGroup } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";

import {
  Button,
  Box,
  Table,
  Tr,
  Th,
  Thead,
  Tbody,
  Td,
} from "@chakra-ui/react";
import CurrencyFormat from "react-currency-format";
import { fetchAsyncUpdatePaymentLimit } from "redux/organizationSlice";
import { useToasts } from "react-toast-notifications";
import { fetchAsyncGetOrganization } from "redux/organizationSlice";
import { fetchAsyncUsePaymentDetails } from "redux/paymentSlice";
import CustomDropdown from "views/admin/vendorDetail/vendorLedger/customDateRenge";
import { financialYearOptions } from "jsFunctions/dateTime";
import { getFirstDayOfMonth } from "jsFunctions/dateTime";
import { getLastDayOfMonth } from "jsFunctions/dateTime";
import SpinnerLoader from "components/Spinner/SpinnerLoader";
import { FaArrowLeft } from "react-icons/fa";
import useOrganizationData from "hooks/organizaton/useOrganization";

const PaymentLimit = () => {
    const moduleType = useSelector((state) => state.moduleType);
    const [amounts, setAmounts] = useState([]);
    const dispatch = useDispatch()
    const { addToast } = useToasts();
    const [loading, setLoading] = useState(false);
    const [payments,setPayments] = useState([])
    const [dateRange, setDateRange] = useState({ startDate: '', endDate: '' });
    const [selectedPeriod, setSelectedPeriod] = useState('currentMonth');
    const [isHistory,setIsHistory] = useState(false)
    const { organizationData } = useOrganizationData();

    const fetchUsePaymentDetails = async (startDate, endDate, type) => {
      setLoading(true);
      const data = { startDate, endDate, type };
  
      try {
        const res = await dispatch(fetchAsyncUsePaymentDetails(data));
        if (res?.payload) {
          setPayments(res.payload || [])
        } else {
          addToast(`${res?.error?.message}`, { appearance: "error" });
        }
      } catch (error) {
        addToast(`Failed to fetch transaction details`, { appearance: "error" });
      } finally {
        setLoading(false);
      }
    };
  
    

    useEffect(() => {
      const payLimits = organizationData?.payLimit || [];
        const initialAmounts = moduleType.map((item) => {
          const limit = payLimits.find((pay)=>pay.modId === item._id)
          const useAmt = payments.find((pay)=>pay.moduleId === item._id)
          return {
            type: item.name, 
            modId: item._id,
            daily: limit?.daily || 0,
            month: limit?.month || 0,
            sts: limit?.sts,
            useAmt:useAmt?.totalUtilized || 0
        }
        })
         
        const allLimit = payLimits.find((item)=>item.type === 'Overall');
        const useAmt = payments.find((pay)=>pay.moduleName === 'Overall')

        setAmounts([{ type: 'Overall', modId: null, daily: allLimit?.daily || 0, month: allLimit?.month || 0 ,sts:allLimit?.sts,useAmt:useAmt?.totalUtilized || 0}, ...initialAmounts]);
    }, [organizationData,moduleType,payments]);


      const handleChange = (index, field, value) => {
        const updatedAmounts = [...amounts];
        if (field === "sts") {
          updatedAmounts[index].sts = value;
        } else {
          updatedAmounts[index][field] = value;
        }
        setAmounts(updatedAmounts);
      };
      
      const handleSave = (e)=>{
        e.preventDefault();
        const id = organizationData._id;

        const formDataToSend = new FormData();
        formDataToSend.append("payLimit", JSON.stringify(amounts));
        dispatch(fetchAsyncUpdatePaymentLimit({ id: id, data: formDataToSend }))
        .then((res) => {
          if (res?.payload) {
            addToast('Payment Limit Updated!', { appearance: "success" });
          }
        })
        .catch((err) => {
          addToast("not Updated", { appearance: "error" });
        });
    };

 
    const dateRanges = {
      lastOneWeek: () => {
        const today = new Date();
        const startDate = new Date(today);
        startDate.setDate(today.getDate() - 6);
        return { startDate, endDate: today };
      },
      last15Days: () => {
        const today = new Date();
        const startDate = new Date(today);
        startDate.setDate(today.getDate() - 14);
        return { startDate, endDate: today };
      },
      currentMonth: () => {
        const today = new Date();
        return { startDate: getFirstDayOfMonth(today), endDate: today };
      },
      lastMonth: () => {
        const today = new Date();
        const prevMonthDate = new Date(today.getFullYear(), today.getMonth() - 1, 1);
        return { startDate: getFirstDayOfMonth(prevMonthDate), endDate: getLastDayOfMonth(prevMonthDate) };
      },
      last3Months: () => {
        const today = new Date();
        const threeMonthsAgo = new Date(today.getFullYear(), today.getMonth() - 2, 1);
        return { startDate: getFirstDayOfMonth(threeMonthsAgo), endDate: today };
      },
      last6Months: () => {
        const today = new Date();
        const sixMonthsAgo = new Date(today.getFullYear(), today.getMonth() - 5, 1);
        return { startDate: getFirstDayOfMonth(sixMonthsAgo), endDate: today };
      },
      currentFinancialYear: () => {
        const today = new Date();
        return { startDate: new Date(today.getFullYear(), 3, 1), endDate: new Date(today.getFullYear() + 1, 2, 31) };
      },
      lastFinancialYear: () => {
        const today = new Date();
        return { startDate: new Date(today.getFullYear() - 1, 3, 1), endDate: new Date(today.getFullYear(), 2, 31) };
      },
      custom: () => ({ startDate: dateRange.startDate, endDate: dateRange.endDate }),
    };
  
    useEffect(() => {
      const { startDate, endDate } = dateRanges[selectedPeriod] ? dateRanges[selectedPeriod]() : { startDate: null, endDate: null };
  
      if (startDate && endDate) {
        fetchUsePaymentDetails(startDate, endDate);
      } 
    }, [selectedPeriod, dateRange]);

  if(loading){
    return <SpinnerLoader/>
  }

  return (
    <>
      <Form>
        <div className="form-card payment-limit-form-card">
          <Box display="flex">

          <h5 className="mt-0">{isHistory ? "Utilized Amount Details" : "Payment Limit"}</h5>
            {isHistory &&
          <Box className="ledger-year-select mx-3">

            <CustomDropdown
              years={financialYearOptions}
              selectedYear={selectedPeriod}
              setSelectedYear={setSelectedPeriod}
              handleApply={(date) => setDateRange(date)}
              dateRenge={dateRange}
            />
          </Box>
            }
            {!isHistory &&
            <Button className="amt-history-btn" onClick={()=>setIsHistory(!isHistory)}> History </Button>
            }
          </Box>
          <Box
            className="payment-limit-form mt-4"
            display="flex"
            flexDirection="column"
          >
            <Table className="mx-0">
              <Thead>
                <Tr>
                  <Th>Label</Th>
                  {!isHistory && <Th>Daily Limit</Th>}
                  {!isHistory && <Th>Monthly Limit</Th>}
                  <Th>Utilized Amount</Th>
                  {!isHistory && <Th>Remaining Amount</Th>}
                    {!isHistory && <Th>Status</Th>}
                </Tr>
              </Thead>
              <Tbody>
                {amounts.map((amount, index) => (
                  <Tr key={index}>
                    <Td className="fw-600">{amount.type}</Td>
                    {!isHistory &&
                    <>
                    <Td>
                      <InputGroup className="input-group">
                        <InputGroup.Text>
                          <span className="rupee-symbol">₹</span>
                        </InputGroup.Text>
                        <CurrencyFormat
                          customInput={Form.Control}
                          className="amount-input"
                          type="text"
                          onValueChange={(e) =>
                            handleChange(index, "daily", e.value)
                          }
                          value={amount?.daily}
                          placeholder="0.00"
                          thousandSeparator={true}
                          decimalScale={2}
                          fixedDecimalScale={true}
                        />
                      </InputGroup>
                    </Td>
                    <Td>
                      <InputGroup className="input-group">
                        <InputGroup.Text>
                          <span className="rupee-symbol">₹</span>
                        </InputGroup.Text>
                        <CurrencyFormat
                          customInput={Form.Control}
                          className="amount-input"
                          type="text"
                          onValueChange={(e) =>
                            handleChange(index, "month", e.value)
                          }
                          value={amount?.month}
                          placeholder="0.00"
                          thousandSeparator={true}
                          decimalScale={2}
                          fixedDecimalScale={true}
                        />
                      </InputGroup>
                    </Td>
                    </>
                    }
                    
                    <Td>
                      <InputGroup className="input-group">
                        <InputGroup.Text>
                          <span className="rupee-symbol">₹</span>
                        </InputGroup.Text>
                        <CurrencyFormat
                          customInput={Form.Control}
                          className="amount-input"
                          type="text"
                          value={amount.useAmt || 0}
                          disabled
                          thousandSeparator={true}
                          decimalScale={2}
                          fixedDecimalScale={true}
                        />
                      </InputGroup>
                    </Td>
                    {isHistory &&
                      <Td width="70%"></Td>
                    }
                    {!isHistory &&
                    <>
                    <Td>
                      <InputGroup className="input-group">
                        <InputGroup.Text>
                          <span className="rupee-symbol">₹</span>
                        </InputGroup.Text>
                        <CurrencyFormat
                          customInput={Form.Control}
                          className="amount-input"
                          type="text"
                          disabled
                          value={(amount?.month - amount?.useAmt) || 0}
                          thousandSeparator={true}
                          decimalScale={2}
                          fixedDecimalScale={true}
                        />
                      </InputGroup>
                    </Td>

                    <Td>
                      <Box className="d-flex">
                        <Form.Check
                          type="checkbox"
                          name="sts"
                          label={amount.sts ? "Enable" : "Not Enable"}
                          checked={amount.sts === true}
                          onChange={(e) =>
                            handleChange(index, "sts", e?.target.checked)
                          }
                        />
                      </Box>
                    </Td>
                    </>
                    }
                  </Tr>
                ))}
              </Tbody>
            </Table>
          </Box>
          {!isHistory ?
          <Button className="btn save-btn mt-3" onClick={(e) => handleSave(e)}>
            Save 
          </Button>
          :
          <Button className="btn save-btn  mt-3" onClick={(e) => {
            setIsHistory(false);
            setSelectedPeriod("currentMonth")
          }}>
           <FaArrowLeft /> <span className="mx-1">Back</span>
          </Button>
          }
        </div>
      </Form>
    </>
  );
};

export default PaymentLimit;
